const regex = /^[0-9A-Z]+$/
const regCM = /^[0-9A-Z\s.-]+$/
const regZW=/[^\x00-\xff]/
const regNum = /^[0-9]+$/
const regZl = /^[0-9]+(\.[0-9]{0,2})?$/
const regCZF=/^[0-9A-Z.,\s()&-]+$/
const regQM=/^[A-Z]+$/

//称重方
export const validCZF=(rule, value, callback)=>{
    if (regCZF.test(value) === false) {
        callback(new Error('只能输入大写字母，数字和.,()&-'))
    }else if(value.length>70){
        callback(new Error('长度必须小于等于70'))
    }else{
        callback()
    }
}
//签名
export const validQM=(rule, value, callback)=>{
    if (regQM.test(value) === false) {
        callback(new Error('只能输入大写字母'))
    }else if(value.length>20){
        callback(new Error('长度必须小于等于20'))
    }else{
        callback()
    }
}
//重量，两位小数
export const validZL=(rule, value, callback)=>{
    if (regZl.test(value) === false) {
        callback(new Error('只能输入两位小数的数字'))
    }else if(value<0 || value>1000000){
        callback(new Error('重量范围0-1000000'))

    }
    else{
        callback()
    }
}
//数字
export const validSO=(rule, value, callback)=>{
    if (regNum.test(value) === false) {
        callback(new Error('只能输入纯数字'))
    }else{
        callback()
    }
}
//提单号
export const validNo=(rule, value, callback)=>{
    if (regex.test(value) === false) {
        callback(new Error('只能输入大写字母和数字'))
    }else{
        callback()
    }
}
//船名
export const validCM=(rule, value, callback)=>{
    if (regCM.test(value) === false) {
        callback(new Error('只能输入大写字母，数字.-'))
    }else{
        callback()
    }
}
// so号
export const validWHLSO=(rule, value, callback)=>{
    if (regex.test(value) === false) {
        callback(new Error('只能输入大写字母和数字'))
    }else{
        callback()
    }
}
//航次
export const validZW=(rule, value, callback)=>{
    if (regZW.test(value) === true) {
        callback(new Error('不能输入中文字符'))
    }else{
        callback()
    }
}
